import { Button, Carousel, Spin, Tabs, Row, Col, Tooltip } from 'antd'
import { SDrawerOrModal, SEditor } from 'shj-components'
import styles from './index.module.less'
import PDFPreview from '../PDFPreview'
import { useEffect } from 'react'
import _ from 'lodash'
import { isValidArray } from '@/utils'
// spu,sku详情
export default function ProductDetailDrawerSpuSku(props: any) {
  const { previewObj, setPreviewObj } = props
  const openNewWindow = (url: string) => {
    if (url.indexOf('http://') !== -1 || url.indexOf('https://') !== -1) {
      window.open(url)
    } else {
      window.open('http://' + url)
    }
  }
  let label: any = {
    fontWeight: '590',
    width: '90px',
    textAlign :'right'
  }
  let desc = {
    whiteSpace: 'nowrap' /* 禁止文本换行 */,
    overflow: 'hidden' /* 超出内容隐藏 */,
    textOverflow: 'ellipsis' /* 显示省略号 */,
    width: '100%' /* 必须设置宽度或最大宽度 */,
    flex: 1,
    paddingRight: '40px',
  }
  // 基本信息banner
  const BannerRender = (props: any) => {
    let { list } = props
    let {
      sourceType,
      name,
      prodName,
      brandName,
      origin,
      specs,
      model,
      sellingPoint,
      unitInfo = {},
      maintenanceDesc,
    } = previewObj?.data ?? {}
    let { materialRemark, purchaseLeadTime, minOrderQuantity, constructionItemDesc, styleNames } =
      previewObj?.data ?? {}
    return (
      <>
        <Carousel arrows infinite={false} className={styles.carouselBox}>
          {(list || [])?.map((item: any) => {
            return (
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  src={item}
                  style={{
                    margin: '0 auto',
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                  }}
                  alt=""
                />
              </div>
            )
          })}
        </Carousel>
        <div>
          <Row style={{ marginTop: '8px' }}>
            <Col span={24}>
              <div style={{ display: 'flex' }}>
                <div style={label}>{name}：</div>
                <Tooltip title={prodName ?? '-'}>
                  <div style={desc}>{prodName ?? '-'}</div>
                </Tooltip>
              </div>
            </Col>
          </Row>
          {/* 物料 */}
          {sourceType === 'MATERIAL' && (
            <>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>品牌：</div>
                    <Tooltip title={brandName ?? '-'}>
                      <div style={desc}>{brandName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>单位：</div>
                    <Tooltip title={unitInfo?.unitName ?? '-'}>
                      <div style={desc}>{unitInfo?.unitName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>起订数：</div>
                    <Tooltip title={minOrderQuantity ?? '-'}>
                      <div style={desc}>{minOrderQuantity ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>产地：</div>
                    <Tooltip title={origin ?? '-'}>
                      <div style={desc}>{origin ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>规格：</div>
                    <Tooltip title={specs ?? '-'}>
                      <div style={desc}>{specs ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>型号：</div>
                    <Tooltip title={model ?? '-'}>
                      <div style={desc}>{model ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>风格：</div>
                    <Tooltip title={styleNames ?? '-'}>
                      <div style={desc}>{styleNames ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>采购提前期：</div>
                    <Tooltip title={purchaseLeadTime ?? '-'}>
                      <div style={desc}>{purchaseLeadTime ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={24}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>卖点：</div>
                    <Tooltip title={sellingPoint ?? '-'}>
                      <div style={desc}>{sellingPoint ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={24}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>保养说明：</div>
                    <Tooltip title={maintenanceDesc ?? '-'}>
                      <div style={desc}>{maintenanceDesc ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <Col span={24}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>备注说明：</div>
                    <Tooltip title={materialRemark ?? '-'}>
                      <div style={desc}>{materialRemark ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
            </>
          )}
          {/* 施工 */}
          {sourceType === 'CONSTRUCTION' && (
            <>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>品牌：</div>
                    <Tooltip title={brandName ?? '-'}>
                      <div style={desc}>{brandName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>单位：</div>
                    <Tooltip title={unitInfo?.unitName ?? '-'}>
                      <div style={desc}>{unitInfo?.unitName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
              <Row style={{ marginTop: '8px' }}>
                <div style={{ display: 'flex' }}>
                  <div style={label}>施工项描述：</div>
                  <Tooltip title={constructionItemDesc ?? '-'}>
                    <div style={desc}>{constructionItemDesc ?? '-'}</div>
                  </Tooltip>
                </div>
              </Row>
            </>
          )}
          {/* 自建 */}
          {sourceType === 'SELF' && (
            <>
              <Row style={{ marginTop: '8px' }}>
                <Col span={14}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>品牌：</div>
                    <Tooltip title={brandName ?? '-'}>
                      <div style={desc}>{brandName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
                <Col span={10}>
                  <div style={{ display: 'flex' }}>
                    <div style={label}>单位：</div>
                    <Tooltip title={unitInfo?.unitName ?? '-'}>
                      <div style={desc}>{unitInfo?.unitName ?? '-'}</div>
                    </Tooltip>
                  </div>
                </Col>
              </Row>
            </>
          )}
        </div>
      </>
    )
  }

  useEffect(() => {
    let productDetailList = previewObj?.data?.attachList ?? []
    let imageUrls = previewObj?.data?.imageUrls
    productDetailList = productDetailList?.map((item: any) => {
      return {
        ...item,
        key: _.uniqueId(),
      }
    })
    let bannerList = [
      {
        attachName: '基本信息',
        content: isValidArray(imageUrls) ? imageUrls : [previewObj?.data?.mainPicUrl],
        contentType: 'banner',
      },
    ]
    productDetailList = [...bannerList, ...productDetailList]
    getDesc(productDetailList || [])
  }, [previewObj?.data?.attachList])
  const getDesc = (descType: any[]) => {
    const data = descType.map(item => ({
      ...item,
      label: (
        <div>
          <span>{item.attachName}</span>
        </div>
      ),
      children: getDetailType(item.contentType, item),
      key: item.key,
    }))
    setPreviewObj({ descType: data })
  }
  const getDetailType = (type: string, obj) => {
    const { attachPath, content } = obj
    const typeObj = {
      banner: <BannerRender list={content} />,
      attachContent: (
        <SEditor readOnly init={{ toolbar: false, menubar: false, plugins: [] }} value={content} />
      ),
      attachPDF: <PDFPreview url={attachPath} />,
      attachVideo: <video style={{ width: '100%' }} src={attachPath} controls={true} />,
      attachURL: (
        <Button type="link" onClick={() => openNewWindow(attachPath)}>
          {attachPath}
        </Button>
      ),
    }
    return typeObj[type]
  }

  return (
    <SDrawerOrModal
      open={previewObj.open}
      title={'产品详情'}
      onCancel={() => setPreviewObj({ open: false, descType: [] })}
      antdProps={{ footer: [], maskClosable: true }}
    >
      <Spin spinning={previewObj.loading}>
        {/* <Carousel arrows infinite={false} autoplay className={styles.carouselBox}>
          {previewObj?.data?.imageUrls?.map((item: any) => {
            return (
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  src={item}
                  style={{
                    margin: '0 auto',
                    objectFit: 'contain',
                    width: '100%',
                    height: '100%',
                  }}
                  alt=""
                />
              </div>
            )
          })}
        </Carousel> */}
        {previewObj.descType?.length ? (
          <Tabs
            tabBarStyle={{ position: 'sticky', top: 0, zIndex: 2, background: '#fff' }}
            items={previewObj.descType}
            hideAdd
          />
        ) : null}
      </Spin>
    </SDrawerOrModal>
  )
}
